export const CDomainModel = {
  ID: '8bc18177e7b947cebf7e8fecc216b81b',
  NAME: 'domain-page',
}
